import { useNavigate } from "react-router-dom";
import type { Article } from "@core/features/support";
import { MdxArticleLinkProvider } from "@themes/pollinator/ui/MdxRenderer";
import { SupportArticle } from "./SupportArticle";
import { useArticleNavigation } from "../../dialogs/ArticleSheet/useArticleNavigation";
import { useFetchSupportArticles } from "@core/features/support";

export type Props = {
  articleId: string | undefined;
  programId?: string;
  className?: string;
};

export function SupportArticleContainer({ articleId, programId, className }: Props) {
  const navigate = useNavigate();

  const { data } = useFetchSupportArticles(programId);
  const articles = data?.articles ?? [];

  const { prev, next } = useArticleNavigation({
    articleId: articleId ?? null,
    programId,
  });

  const article = articles.find((article) => article.id === articleId);

  if (!article) {
    return null;
  }

  const handleNavigationClick = (article: Article) => {
    navigate(`/program/${programId}/support/${article.id}`);
  };

  const handleArticleSelect = (slug: string) => {
    navigate(`/program/${programId}/support/${slug}`);
  };

  return (
    <MdxArticleLinkProvider onArticleSelect={handleArticleSelect}>
      <SupportArticle
        article={article}
        className={className}
        prev={prev}
        next={next}
        onNavigationClick={handleNavigationClick}
      />
    </MdxArticleLinkProvider>
  );
}

export default SupportArticleContainer;

